import { render, staticRenderFns } from "./IconBubbleFrench.vue?vue&type=template&id=3b2297f8&"
import script from "./IconBubbleFrench.vue?vue&type=script&lang=js&"
export * from "./IconBubbleFrench.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports